
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import TwitterIcon from '@mui/icons-material/Twitter';

export const SocialNetworkData = [
    {
        title: "Linkedin",
        link: "https://www.linkedin.com/in/francesc-xavier-bullich-parra-469726122/",
        icon: <LinkedInIcon />
    },
    {
        title: "Github",
        link: "https://github.com/fxbp",
        icon: <GitHubIcon />
    },
    {
        title: "Twitter",
        link: "https://twitter.com/FrancescBullich",
        icon: <TwitterIcon />
    }
]